import React, { useEffect } from "react";
import Div100vh from "react-div-100vh";
import { useLocation, useNavigate } from "react-router-dom";

export default function TransitionScreen() {
  const location = useLocation();
  const navigate = useNavigate();

  const customMessage = location?.state?.customMessage || "";
  const name = location?.state?.name || "";
  const path = location?.state?.path || "";

  useEffect(() => {
    if (path) {
      const timeout = setTimeout(() => {
        navigate(path);
      }, 2000);

      return () => clearTimeout(timeout);
    }
  }, [path, navigate]);

  return (
    <Div100vh className="bg-white text-black">
      <div className="w-full h-full flex font-medium justify-center items-center animate-pulse">
        {customMessage ? (
          <span>{customMessage}</span>
        ) : (
          <>
            <span>Redirecting to...</span>
            <span className="text-[#1987fb] capitalize font-bold animate-none">
              {name}
            </span>
          </>
        )}
      </div>
    </Div100vh>
  );
}
